import React, { useEffect, useState } from "react";
import api from "@/lib/api";

const URGENCIES = [
  { key: "emergency", label: "Emergency (today)" },
  { key: "asap", label: "Within 72 hours" },
  { key: "this_week", label: "This week" },
  { key: "this_month", label: "This month" },
  { key: "flexible", label: "Flexible" },
];
const WINDOWS = ["Morning", "Afternoon", "Evening", "Weekend", "Any time"];
const pill = (on) => `rounded-xl border px-3 py-2.5 text-sm transition-colors ${on ? "border-[#165a71] bg-[#165a71] text-white" : "border-slate-200 bg-white hover:border-[#165a71]/50"}`;

export default function WhereWhenStep({ req, set }) {
  const addr = req.address_snapshot || {};
  const setAddr = (k, v) => set("address_snapshot", { ...addr, [k]: v });
  const local = req.kind === "local";
  const [saved, setSaved] = useState([]);
  useEffect(() => {
    if (local && !addr.state) set("address_snapshot", { ...addr, state: "FL" });
    if (local) api.get("/addresses").then(({ data }) => setSaved(Array.isArray(data) ? data : data?.items || [])).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const pickSaved = (a) => set("address_snapshot", { ...addr, line1: a.line1, city: a.city, state: a.state, zip_code: a.zip, saved_address_id: a.id });
  return (
    <div className="space-y-6" data-testid="where-when-step">
      <div className="font-display text-xl font-semibold text-[#071b22]">{local ? "Where & when" : "Timeline"}</div>
      {local && (
        <div>
          <div className="text-sm font-semibold text-[#071b22] mb-2">Job location <span className="text-[#d97757]">*</span></div>
          {saved.length > 0 && (
            <div className="mb-3 flex flex-wrap gap-2" data-testid="saved-addresses">
              {saved.map((a) => <button type="button" key={a.id} onClick={() => pickSaved(a)} className={pill(addr.saved_address_id === a.id)} data-testid={`saved-address-${a.id}`}>{a.label} - {a.city}</button>)}
              <button type="button" onClick={() => set("address_snapshot", { state: addr.state || "FL", zip_code: addr.zip_code })} className={pill(false)} data-testid="saved-address-other">Use another address</button>
            </div>
          )}
          <div className="grid gap-3 sm:grid-cols-[2fr_1fr_1fr]">
            <input placeholder="Street address (shared only with the pro you hire)" value={addr.line1 || ""} onChange={(e) => setAddr("line1", e.target.value)} className="sr-input sm:col-span-3" data-testid="addr-line1" />
            <input placeholder="City" value={addr.city || ""} onChange={(e) => setAddr("city", e.target.value)} className="sr-input" data-testid="addr-city" />
            <select value={addr.state || "FL"} onChange={(e) => setAddr("state", e.target.value)} className="sr-input" data-testid="addr-state">
              {["FL", "AL", "MS", "LA", "TX"].map((s) => <option key={s}>{s}</option>)}
            </select>
            <input placeholder="ZIP" value={addr.zip_code || ""} onChange={(e) => setAddr("zip_code", e.target.value)} className="sr-input" data-testid="addr-zip" />
          </div>
        </div>
      )}
      <div>
        <div className="text-sm font-semibold text-[#071b22] mb-2">How soon? <span className="text-[#d97757]">*</span></div>
        <div className="flex flex-wrap gap-2">
          {URGENCIES.map((u) => <button type="button" key={u.key} onClick={() => set("urgency", u.key)} className={pill(req.urgency === u.key)} data-testid={`urgency-${u.key}`}>{u.label}</button>)}
        </div>
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <label className="block">
          <div className="text-sm font-semibold text-[#071b22] mb-2">{local ? "Preferred date" : "Deadline"}</div>
          <input type="date" value={(local ? req.preferred_start_date : req.deadline)?.slice(0, 10) || ""} onChange={(e) => set(local ? "preferred_start_date" : "deadline", e.target.value || null)} className="sr-input" data-testid="pref-date" />
        </label>
        {local && (
          <div>
            <div className="text-sm font-semibold text-[#071b22] mb-2">Best time</div>
            <div className="flex flex-wrap gap-2">
              {WINDOWS.map((w) => <button type="button" key={w} onClick={() => set("time_window", w)} className={pill(req.time_window === w)} data-testid={`window-${w}`}>{w}</button>)}
            </div>
          </div>
        )}
      </div>
      <div className="flex flex-wrap gap-4 text-sm">
        <label className="inline-flex items-center gap-2"><input type="checkbox" checked={!!req.require_insurance} onChange={(e) => set("require_insurance", e.target.checked)} data-testid="req-insurance" /> Pro must be insured</label>
        <label className="inline-flex items-center gap-2"><input type="checkbox" checked={!!req.require_background_check} onChange={(e) => set("require_background_check", e.target.checked)} data-testid="req-bg" /> Background-checked pros only</label>
      </div>
    </div>
  );
}
